import React from 'react';
import { AuthorizedComponent } from 'react-router-role-authorization';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import * as UserActions from './../actions/user_actions';
import { bindActionCreators } from 'redux';

class AdminContainer extends AuthorizedComponent {
  constructor(props) {
    super(props);

    // Redirection of Url pasting
    let currentUserRole = null;
    if (this.props.LogingDetails) {
      currentUserRole = this.props.UserDetails.selectedUserRoleID;
    }
    else {
      currentUserRole = "Dummy"
    }

    this.userRoles = [currentUserRole];
    this.notAuthorizedPath = '/';
  }

  // handleUnauthorizedRole(routeRoles, userRoles){
  //   // handle unsuccessful authorization somehow
  //   console.log(`Route is available for roles: ${routeRoles}, but your roles are: ${userRoles}...`);

  //   // you should still redirect somewhere else if you want to prevent from accessing the restricted route ...
  //   // ... or just use the default behaviour by calling `super.handleUnauthorizedRole()`
  //   const { router } = this.context;
  //   router.push('/');
  // }

  render() {
    return (
      <div>
        {this.props.children}
      </div>
    );
  }
}

//export default AdminContainer;

let mapStateToProps = (state) => {

  return {
    UserDetails :state.User,
    LogingDetails: state.User.loginData,
  };
};

let mapDispatchToProps = (dispatch) => ({
  UserActions: bindActionCreators(UserActions, dispatch),
  Dispatch: dispatch
});

export default connect(mapStateToProps,
  mapDispatchToProps)(withRouter(AdminContainer));



/** WEBPACK FOOTER **
 ** ./src/components/adminContainer.js
 **/